import React, { useState, useEffect, useRef } from "react";
import { Button, Chip } from "../../../common/commonIndex";
import { Image } from "../../../components/componentIndex";
import CancelIcon from "../../../assets/images/doctorProfile/close-icon.svg";
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import CommonService from "../../../services/API/commonService";

const SearchMedications = ({ handleNextEvent, formData, questionData }) => {
    const [searchMedicationsList, setSearchMedicationsList] = useState([]);
    const [patientsMedicines, setPatientsMedicines] = useState([]);
    const [selectedNoneValue, setSelectedNoneValue] = useState('');
    const { state: authState } = useAuthenticationContext();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSetDefault, setIsSetDefault] = useState(false);
    const [isMessagePopup, setIsMessagePopup] = useState(false);
    const [message, setMessage] = useState(null);
    const popupRef = useRef(null);

    useEffect(() => {
        setSearchMedicationsList(
            questionData?.listOfAnswers?.filter(
                (x) => x?.answer?.toLowerCase() !== "none"
            ) || formData?.answer || []
        );
        if (questionData?.listOfAnswers?.length > 0 || formData?.answer?.length > 0) {
            if (formData?.answer?.length > 0) {
                setSearchMedicationsList(formData?.answer);
            }
            setIsDisabled(true);
        }
        fetchAllPatientsMedicines();
    }, [questionData]);

    const fetchAllPatientsMedicines = async () => {
        try {
            const token = authState?.userData?.result?.token;
            const response = await CommonService.getAllPatientsMedicines(token);
            if (response?.statusCode === 200) {
                setPatientsMedicines(response?.result || []);
            }
        } catch (error) {
            console.error("Error fetching patient medicines:", error);
        }
    };

    const handleSubmit = () => {
        formData.answer = searchMedicationsList;

        if (questionData?.listOfAnswers?.length > 0) {
            const filterList = questionData?.listOfAnswers?.filter(
                (x) => !x.answer?.includes("None")
            );
            formData.fkAnswerIds = filterList
                ?.filter((x) => searchMedicationsList?.includes(x.answer))
                .map((x) => x.id);
        } else {
            formData.fkAnswerIds = searchMedicationsList;
        }

        const skip = 1;
        const storedData = getLocalStorageData() || {};
        storedData[questionData?.questionerIndex] = formData;
        setLocalStorageData(storedData);

        handleNextEvent(questionData?.questionerIndex + skip);
    };

    const getLocalStorageData = () => {
        return JSON.parse(localStorage.getItem("listOfAnswer"));
    };

    const setLocalStorageData = (data) => {
        localStorage.setItem("listOfAnswer", JSON.stringify(data));
    };

    const handleChipDelete = (chipToDelete) => {
        setSearchMedicationsList((prevList) =>
            prevList.filter((chip) => chip !== chipToDelete)
        );
        if(searchMedicationsList?.length === 1){
            if(searchMedicationsList?.length === 0 || searchMedicationsList[0] === chipToDelete){
                setSelectedNoneValue('');
            }
        }
    };

    const handleSelectDefaultValue = () => {
        setIsDisabled(true);
        setSearchMedicationsList(["None"]); // Clear other selections and add "None"
        setSelectedNoneValue('None');
    };

    // const handleAddMedication = (medication) => {
    //     setIsDisabled(true);
    //     setSearchMedicationsList((prevList) => {
    //         if (prevList.includes("None")) {
    //             return [medication]; // Replace "None" with the new selection
    //         }
    //         return prevList.includes(medication)
    //             ? prevList
    //             : [...prevList, medication]; // Add unique medication
    //     });
    // };

    const handleAddMedication = (medication) => {
        let findSelectedValue;
        if (medication?.length > 0) {
            findSelectedValue = medication?.find(x => x);
        }
        setIsDisabled(true);
        let filterData = findSelectedValue?.toLowerCase() === "none" ? true : searchMedicationsList?.filter(x => x === findSelectedValue)?.length === 0;
        if (filterData) {
            setSearchMedicationsList((prevList) => {
                if (prevList.includes("None")) {
                    return [findSelectedValue]; // Replace "None" with the new selection
                }
                return prevList.includes(findSelectedValue)
                    ? prevList
                    : [...prevList, findSelectedValue]; // Add unique medication
            });
        } else {
            setMessage(`${findSelectedValue} already exists in the list.`);
            openMessagePopup();
            // alert(`${medication[0]} already exists in the list.`);
        }

    };


    const safeSearchMedicationsList = Array.isArray(searchMedicationsList) ? searchMedicationsList : [];

    const openMessagePopup = () => {
        setIsMessagePopup(true);
    };

    const closeMessagePopup = () => {
        setIsMessagePopup(false);
    };
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsMessagePopup(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [closeMessagePopup]);

    const getChipsList = (searchAllergiesList) => {
        if(searchAllergiesList?.length === 0){return [];}
       const findNoneList = searchAllergiesList?.filter(x => x.toLowerCase() === 'none')?.length === 0;
       if(findNoneList){
        return searchAllergiesList;
       }else{
        return [];
       }
    }
    return (
        <div>
            <h3 className="title">{questionData?.question}</h3>
            <div className="eligibility questionnaire">
                <form>
                    <div>
                        <Chip
                            type={"text"}
                            placeholderName={"Search medications"}
                            list={safeSearchMedicationsList}
                            setSearchMedicationsList={handleAddMedication}
                            setIsSetDefault={setIsSetDefault}
                            selectedNoneValue={selectedNoneValue}
                            setIsDisabled={setIsDisabled}
                            isInputClear={true}
                        />


                    </div>
                    {safeSearchMedicationsList?.length > 0 ? (
                        <div
                            className={
                                safeSearchMedicationsList?.length > 15
                                    ? `scrollbar colonoscopy-scrollbar`
                                    : ""
                            }
                        >
                            <div
                                className={
                                    safeSearchMedicationsList?.length > 15
                                        ? `force-overflow`
                                        : ""
                                }
                            >
                                <div className="d-flex flex-wrap justify-content-start align-items-start">
                                    {getChipsList(safeSearchMedicationsList)?.map((chip, index) => (
                                        <div className="me-3" key={index}>
                                            <div className="chips">
                                                <span>{chip} </span>
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={() => handleChipDelete(chip)}
                                                >
                                                    <Image
                                                        imgUrl={CancelIcon}
                                                        altText={""}
                                                        className={"remove"}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div
                            style={{ width: "51px" }}
                            className={`chips cursor-pointer ${selectedNoneValue ? 'd-none' : ''}`}
                            onClick={handleSelectDefaultValue}
                        >
                            <span>None</span>
                        </div>
                    )}
                </form>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider"></div>
                <div className="footer-content">
                    <div className="skip-eligibility"></div>
                    <Button
                        btnClass={"btn-primary question-btn"}
                        btnType={"button"}
                        btnName={"Continue"}
                        onClick={handleSubmit}
                        isDisabled={isDisabled && safeSearchMedicationsList.length > 0 ? true : false}
                    />
                </div>
            </div>
            {isMessagePopup && (
                <div className="fullscreen-overlay">
                    <div className={`fullscreen-overlay-content alert-fullscreen-overlay alert-popup`} ref={popupRef}>
                        <h2 className={`title mt-5 mb-4`}>
                            {message}
                        </h2>
                        <Button btnClass={`btn-primary`}
                            btnName={'Close'}
                            btnType={'button'}
                            onClick={closeMessagePopup}
                            isDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchMedications;
